import { orchestrator } from 'satcheljs';
import {
    onIsDraftChanged,
    saveAndSendDraft,
    saveEventDraft,
} from 'owa-calendar-compose-form-actions';

orchestrator(saveAndSendDraft, actionMessage => {
    onIsDraftChanged(true, actionMessage.formId);
    saveEventDraft(actionMessage.formId, true /* shouldForceCloseOnSend */);
});
